<ng-container *ngIf="user">
  <app-card
    [type]="2"
    [imgSrc]="(user?.profile?.avatar_url | mediaUrl:true) ?? 'assets/avatars/default-user-avatar.png'"
    [title]="'feature.account.profile' | translate"
    [showEditButton]="user?.username===(currentUser$ | async)?.user_name"
    (showEditForm)="showEditForm=!showEditForm"
  >
    <span cardButton2><i class="bi bi-person-check"></i></span>
    <div cardText2>
      <ng-container *ngIf="user?.username===(currentUser$ | async)?.user_name; else notOwnProfileBlock">
        <h6 class="d-inline">{{ 'feature.account.username' | translate }}:&nbsp;</h6>
        <span class="text-secondary">{{user?.profile?.user_name}}</span>
        <br />
        <h6 class="d-inline">{{ 'feature.account.first_name' | translate }}:&nbsp;</h6>
        <span class="text-secondary">{{user?.profile?.first_name}}</span><br />
        <h6 class="d-inline">{{ 'feature.account.last_name' | translate }}:&nbsp;</h6>
        <span class="text-secondary">{{user?.profile?.last_name}}</span><br />
        <h6 class="d-inline">{{ 'feature.account.birth_date' | translate }}:&nbsp;</h6>
        <span *ngIf="user?.profile?.date_of_birth" class="text-secondary"> {{user?.profile?.date_of_birth | date: 'dd/MM/yyyy' }}</span>
        <br />
        <h6 class="d-inline">{{ 'feature.account.gender' | translate }}:&nbsp;</h6>
        <span> <i *ngIf="user?.profile?.gender; else female" class="bi bi-gender-male text-primary"></i></span>
        <br />
        <h6 class="d-inline">Email:&nbsp;</h6>
        <span *ngIf="user?.profile?.email" class="text-secondary">{{user?.profile?.email}}</span>
      </ng-container>
    </div>
    <ng-template #notOwnProfileBlock>
      <h6 class="d-inline">{{ 'feature.account.username' | translate }}:&nbsp;</h6>
      <span class="text-secondary">{{user.username}}</span>
      <br />
      <h6 class="d-inline">{{ 'feature.account.first_name' | translate }}:&nbsp;</h6>
      <span class="text-secondary">**********</span>
      <h6 class="d-inline">{{ 'feature.account.last_name' | translate }}:&nbsp;</h6>
      <span class="text-secondary">**********</span>
      <h6 class="d-inline">{{ 'feature.account.birth_date' | translate }}:&nbsp;</h6>
      <span *ngIf="!user?.profile?.date_of_birth" class="text-secondary">**********</span>
      <br />
      <h6 class="d-inline">{{ 'feature.account.gender' | translate }}:&nbsp;</h6>
      <span> <i *ngIf="user?.profile?.gender; else female" class="bi bi-gender-male text-primary"></i></span>
      <br />
      <h6 class="d-inline">Email:&nbsp;</h6>
      <span *ngIf="!user?.profile?.email && user?.profile?.email !== null" class="text-secondary">**********</span><br />
    </ng-template>
  </app-card>
</ng-container>
<div *ngIf="showEditForm" class="update_profile">
  <app-card [type]="3" [title]="'feature.account.update_profile' | translate">
    <app-update-profile cardText3 (updateEvent)="onUpdate($event)"></app-update-profile>
  </app-card>
</div>
<ng-template #female>
  <i class="bi bi-gender-female" style="color: hotpink"></i>
</ng-template>
